/* eslint-disable arrow-body-style */
import { updateBookItem } from '../actionCreators';
import { updateEditInfo } from '../status/actionCreators';

const updateBook = (bookId, updatedInfo) => {
  return async dispatch => {
    const response = await fetch(`http://localhost:9000/books/${bookId}`, {
      method: 'PATCH',
      body: JSON.stringify({
        ...updatedInfo,
      }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
    });
    const updatedBook = await response.json();
    dispatch(updateEditInfo());
    dispatch(updateBookItem(bookId, updatedBook));
  };
};

export default updateBook;
